import {memo, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../../components/Selection'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useSalesOrganization} from '../../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterDate, setMasterSupplyPoint} from '../../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../../components/Table/Table'
import { useRegions } from 'src/hooks/useRegions'
import { useCities } from 'src/hooks/useCities'

const statusOptions = [
  {value: 'y', label: 'Active'},
  {value: '!y', label: 'Inactive'},
]

export const RowFilter = memo(() => {
  const {t} = useTranslation()

  const {filterSupplyPoint: filter} = useAppSelector(filterSelector)
  const {salesOrgOptions} = useSalesOrganization()
  const {options: regionOptions} = useRegions()
  const {options: citiesOptions} = useCities(filter.province_id)

  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setMasterSupplyPoint({...filter, ...value}))
  }

  useEffect(() => {
    let _filter = filter
    try{
      let storage = localStorage.getItem('redux-sp-filter') as string

      if (storage) {
        let persisted = JSON.parse(storage)
        _filter = {
          ...filter,
          ...persisted
        }
        dispatch(setMasterSupplyPoint(_filter))
      }

    }catch(e){
      console.log(e)
    }
  }, [])

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <Selection
          placeholder={t('Sales Org')}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('sub-order-provinsi')}
          data={regionOptions}
          value={filter?.province_id ?? ''}
          onChange={(value: any) => handleFilterChange({province_id: value ?? ''})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('sub-order-kota')}
          data={citiesOptions}
          disabled={!filter.province_id}
          value={filter?.city_id ?? ''}
          onChange={(value: any) => handleFilterChange({city_id: value ?? ''})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Plant Code')}
          value={filter?.plant_code ?? ''}
          onChange={({target}) => handleFilterChange({plant_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Plant')}
          value={filter?.plant ?? ''}
          onChange={({target}) => handleFilterChange({plant: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Sales Group')}
          value={filter?.secound_sales_group ?? ''}
          onChange={({target}) => handleFilterChange({secound_sales_group: target.value})}
        />
      </td>
      <td>
        <Selection
          data={statusOptions}
          placeholder={'Status'}
          value={filter?.status ?? ''}
          onChange={(status) => handleFilterChange({status})}
        />
     </td>
      <td className='td-order-1 text-center pm-0'>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
})
